import { createFileRoute } from '@tanstack/react-router';
import { STEP_KEYS, type ImportMethod, type WizardStep } from '@/pages/Entities/bulk-import/store';

interface BulkImportSearch {
  step: WizardStep;
  method?: ImportMethod;
}

/**
 * `/entities/bulk-import` — full-page bulk-import wizard.
 * URL owns navigation: `step` selects the wizard stage, `method` the chosen flow.
 * Illegal values fall back to the method-selection step.
 */
export const Route = createFileRoute('/entities/bulk-import')({
  validateSearch: (search: Record<string, unknown>): BulkImportSearch => {
    const step = STEP_KEYS.includes(search.step as WizardStep)
      ? (search.step as WizardStep)
      : 'method';
    const method =
      search.method === 'own-file' || search.method === 'template'
        ? (search.method as ImportMethod)
        : undefined;
    // A step other than `method` is meaningless without a chosen flow.
    return { step: method ? step : 'method', method };
  },
});
